import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";

/** Site-wide announcement strip, driven by the single active item in Content → Announcements.
 * Dismissing it is remembered per-announcement in localStorage so it doesn't reappear on every page.
 * Reports its own visibility up via onVisibilityChange so Layout can shift the fixed header down. */
export const AnnouncementBanner = ({ onVisibilityChange }) => {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api
      .get("/content/announcement")
      .then(({ data }) => {
        if (data && localStorage.getItem(`dismissed_announcement_${data.id}`) !== "1") {
          setAnnouncement(data);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    onVisibilityChange?.(!!announcement && !dismissed);
  }, [announcement, dismissed, onVisibilityChange]);

  const dismiss = () => {
    if (announcement) localStorage.setItem(`dismissed_announcement_${announcement.id}`, "1");
    setDismissed(true);
  };

  if (!announcement || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-stranger-orange text-clean-white px-4 h-11 flex items-center justify-center gap-3 text-xs sm:text-sm font-bold" data-testid="announcement-banner">
      <span className="text-center truncate">
        {announcement.title}
        {announcement.body ? ` — ${announcement.body}` : ""}
        {announcement.link_url && (
          <a href={announcement.link_url} className="underline ml-2" data-testid="announcement-banner-link">
            {announcement.link_label || "Learn more"}
          </a>
        )}
      </span>
      <button onClick={dismiss} data-testid="announcement-banner-dismiss" className="absolute right-4 hover:opacity-70" aria-label="Dismiss announcement">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
